var map = {
	"./catchAll.jpg": 504,
	"./dish-1.jpg": 505,
	"./dish-10.jpg": 506,
	"./dish-11.jpg": 507,
	"./dish-12.jpg": 508,
	"./dish-13.jpg": 509,
	"./dish-2.jpg": 510,
	"./dish-3.jpg": 511,
	"./dish-4.jpg": 512,
	"./dish-5.jpg": 513,
	"./dish-6.jpg": 514,
	"./dish-7.jpg": 515,
	"./dish-8.jpg": 516,
	"./dish-9.jpg": 517
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dishes nonrecursive \.(png|jpe?g|svg)$
// module id = 187
// module chunks = 0